<template>
  <el-tooltip
    v-if="statuses[status]"
    effect="dark"
    placement="bottom-end"
    :content="statuses[status].desc"
  >
    <span>Статус потока: <i class="stream-status" :class="statuses[status].icon" style="position: relative; top: 1.1px;"/></span>
  </el-tooltip>
</template>

  <script>
  export default {
    name: "CameraStreamStatus",
    props: {
      status: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        statuses: {
            online: {
                icon: "el-icon-success",
                desc: "Камера включена",
            },
            offline: {
                icon: "el-icon-warning",
                desc: "Камера отключена",
            },
            error: {
                icon: "el-icon-error",
                desc: "Проблема с потоком",
            },
            sleep: {
                icon: "el-icon-moon",
                desc: "В спящем режиме из-за длительного периода неактивности",
            },
        },
      };
    },
  };
  </script>

  <style lang="scss">
  .stream-status {
    margin-right: 16px;
  }
  .status-switch {
    &,
    & * {
      cursor: default;
    }
  }
  .el-icon-error.stream-status {
    color: #fa5555;
  }
  .el-icon-success.stream-status {
    color: #67c23a;
  }
  .el-icon-warning.stream-status {
    color: #409eff;
  }
  </style>
